export function Truncate(source, size) {
    return source && source?.length > size ? source?.slice(0, 20) + "…" : source;
  }

  export function Truncate2(source, size) {
    return source && source?.length > size ? source?.slice(0, size - 1 ) + "…" : source;
  }